module.exports = __webpack_public_path__ + "img/1450761132.80368881.jpg";